import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Image } from 'primereact/image';
import { Sidebar } from 'primereact/sidebar';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useNavigate } from 'react-router-dom';

import SidebarContainer from '../components/SidebarContainer.jsx';
import { setBodyPage } from '../lib/functions.js';
import fetchApi from '../lib/fetchApi.js';

const LayoutDashboard = ({ pageParams }) => {
  const navigate = useNavigate();
  const [sidebarVisible, setSidebarVisible] = useState(false);

  useEffect(() => {
    (async () => {
      const response = await fetchApi('/api/v1/user/getMe');
      if (response?.state !== 1 || !response.data?.user) {
        navigate('/');
      }
    })();
  }, []);

  useEffect(() => {
    setBodyPage(pageParams?.alias);
  }, [pageParams]);

  const customHeader = (
    <div className="flex align-items-center gap-2">
      <Image src="/images/likkan-icon.jpg" alt="Image" width="30" pt={{ image: { className: 'block' } }} />
      <span className="font-bold">力勤物流搬運</span>
    </div>
  );

  return (
    <div className="likkan-shell">
      <div className="likkan-topbar">
        <div className="likkan-topbar-left">
          <Button
            icon="pi pi-bars"
            size="small"
            onClick={() => setSidebarVisible(true)}
            severity="secondary"
          />
          <span className="likkan-topbar-title">{pageParams?.title}</span>
        </div>
        <Image src="/images/likkan-icon.jpg" alt="Image" width="40" pt={{ image: { className: 'block' } }} />
      </div>
      <div className="likkan-main">
        <Outlet />
      </div>
      <Sidebar
        className="likkan-sidebar"
        visible={sidebarVisible}
        onHide={() => setSidebarVisible(false)}
        header={customHeader}
        pt={{ content: { className: 'p-0' } }}
      >
        <SidebarContainer currentPageAlias={pageParams?.alias} />
      </Sidebar>
      {/* Single global confirm dialog — every page / component calls
          `confirmDialog({ ... })` from primereact/confirmdialog; multiple
          <ConfirmDialog /> instances would each register a listener and
          trigger duplicate dialogs. */}
      <ConfirmDialog />
    </div>
  );
};

export default LayoutDashboard;
